import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { customSizes } from '../../assets/styles/themes/tokens';

const OwnCollectionOverviewWatchlistEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Box data-testid='own-collection-overview-watchlist-empty-state'>
      <EmptySearchStateImage
        title={t('No materials in Merkliste')}
        subtitle={t('You have not saved any materials in Merkliste yet')}
        containerSx={{ padding: 0, textAlign: 'center' }}
        iconContainerSx={{ width: customSizes.ownCollectionOverview.watchlistWidth }}
      />
    </Box>
  );
};

export default OwnCollectionOverviewWatchlistEmptyState;
